// extracted by mini-css-extract-plugin
export default {"var-select-modal":"var-select-modal__var-select-modal"};